import classes from './SubmissionGraph.module.css'
import AverageSubmissions from '../../../../../lms-shared/StudentStatistics/AverageSubmissions'
import { throwApiError } from "../../../../../lms-shared/store/error-handling-actions";
import { submissionStatisticApi } from '../../../../../../utils'
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';

const SubmissionGraph = ({ studentsSubmmissionList }) => {
    const avergeScore = studentsSubmmissionList.assessments.reduce((total, next) => total + next.AvgSubmissions, 0) / studentsSubmmissionList.assessments.length;
    // const { id } = useParams();
    // const dispatch = useDispatch()
    const texts = useSelector(state => state.translate.texts);
    const [courseSubmissionAverage, setCourseSubmissionAverage] = useState(0)

    // const getCourseSubmissionAverage = () => {
    //     const data =
    //     {
    //         studyGroupId: id
    //     }

    //     submissionStatisticApi.submissionStatisticsCourseSubmissionAveragePost({ submissionStatisticInput: data }, (error, resdata, response) => {
    //         if (error) {
    //             dispatch(throwApiError({ userMessage: 'error from submissionStatisticsCourseSubmissionAveragePost', error: error, statusCode: response?.statusCode, message: "submissionStatisticsCourseSubmissionAveragePost " + error.message, level: 1, component: "SubmissionGraph", line: 24 }))
    //         }
    //         else {
    //             setCourseSubmissionAverage(resdata)
    //         }
    //     })
    // }

    // useEffect(() => {
    //     // getCourseSubmissionAverage()
    // }, [id])

    return (
        <div className={classes.ChartSize}>
            <AverageSubmissions avergeScore={Math.round(avergeScore * 100)} avergeClass={Math.round(courseSubmissionAverage * 100)} generalAverageText={texts.nationalAverage}></AverageSubmissions>
        </div>
    )
}
export default SubmissionGraph